import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useBiometricAuth } from '../../hooks/useBiometricAuth';
import { clearBiometricToken } from '../../services/biometricService';
import { registerPushNotifications } from '../../services/pushNotificationService';
import BiometricUnlockScreen from './BiometricUnlockScreen';

/**
 * Wraps children and shows the biometric unlock screen when the app is locked.
 * Must be rendered inside AuthProvider and Router.
 */
const BiometricGate = ({ children }) => {
  const { isLocked, unlockWithBiometric, logoutUser } = useContext(AuthContext);
  const { biometryType, error, attemptBiometricUnlock } = useBiometricAuth();
  const history = useHistory();

  const handleUnlock = async () => {
    const result = await attemptBiometricUnlock();
    if (result) {
      await unlockWithBiometric(result.token, result.user);
      registerPushNotifications(result.token);
      history.replace('/dashboard');
    }
  };

  const handleUsePassword = async () => {
    await clearBiometricToken();
    logoutUser();
  };

  if (isLocked) {
    return (
      <BiometricUnlockScreen
        biometryType={biometryType}
        onUnlock={handleUnlock}
        onUsePassword={handleUsePassword}
        error={error}
      />
    );
  }

  return children;
};

export default BiometricGate;
